
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/breakfast/[...slug]",
      function () {
        return require("private-next-pages/breakfast/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/breakfast/[...slug]"])
      });
    }
  